export default {
	route: {
		dashboard: '首页',
		profile: '个人中心',
		communicat: '沟通管理',
		reportManage: '报表管理',
		customerManage: '客户管理',
		telChannel: '电话渠道',
		hotLine: '热线管理',
		phoneRecords: '电话记录',
		videoCall: '视频通话邀请',
		mesQuery: '留言查询',
		pesCallRecords: '个人通话记录查询',
		callRecords: '通话记录查询',
		OBRecord: 'OB转接记录查询',
		monitor: '监控',
		phoneMonitor: '电话监控',
		callOutMonitor: '外呼监控',
		call: '外呼中心',
		questSurver: '问卷调查',
		callOutState: '外呼状态',
		orgData: '原始数据',
		callOutActivity: '外呼活动',
		callOutTask: '外呼任务',
		callOutTheme: '外呼主题',
		performOutbound: '执行外呼',
		callOutTable: '外呼报表',
		IMChannel: 'IM渠道',
		serviceWindow: '服务窗口',
		queueManage: '队列管理',
		holidayManage: '节假日管理',
		imMonitor: 'IM坐席监控',
		msgManage: '留言管理',
		holidayWords: '节假日话术配置',
		weChatChannel: '微信渠道',
		smsChannel: '短信渠道',
		emailChannel: '邮件渠道',
		emailAccount: '邮件账户设置',
		mailTask: '邮件任务处理',
		mailTemp: '邮件模板设置',
		inbox: '收件箱',
		outbox: '发件箱',
		dustbin: '垃圾箱',
		drafts: '草稿箱',
		favorites: '收藏夹',
		newEmail: '新建邮件',
		weiboChannel: '微博渠道',
		workOrderManage: '工单管理',
		connectPlan: '联系计划',
		isc: '智能客服',
		system: '系统配置'
	},
	navbar: {
		dashboard: '首页',
		logOut: '退出登录',
		profile: '用户设置',
	},
	server: {
		rest: '休息',
		processing: '话后处理中',
		cultivate: '培训',
		meeting: '会议',
		dine: '吃饭',
		leisure: '空闲',
		offline: '离开'
	},
	login: {
		title: '欢迎登录迈睿OCS+2.0',
		titleDesc: '登录成功后即可体验整体产品服务系统',
		logIn: '登录',
		username: '服务注册的账号信息',
		password: '登录服务账号的密码',
		inputnumber: '账号',
		inputpassword: '密码',
		inpuverification: '验证码'
	},
	logoImg: {
		corporate: '品牌企业文化标语',
		carousel: '轮播图',
	},
	table: {
		dynamicTips1: '固定表头, 按照表头顺序排序',
		dynamicTips2: '不固定表头, 按照点击顺序排序',
		dragTips1: '默认顺序',
		dragTips2: '拖拽后顺序',
		title: '标题',
		importance: '重要性',
		type: '类型',
		remark: '点评',
		search: '搜索',
		add: '添加',
		export: '导出',
		reviewer: '审核人',
		id: '序号',
		date: '时间',
		author: '作者',
		readings: '阅读数',
		status: '状态',
		actions: '操作',
		edit: '编辑',
		publish: '发布',
		draft: '草稿',
		delete: '删除',
		cancel: '取 消',
		confirm: '确 定'
	},

	excel: {
		export: '导出',
		selectedExport: '导出已选择项',
		placeholder: '请输入文件名(默认excel-list)'
	},
	tagsView: {
		closeOthers: '关闭其他',
		closeAll: '全部关闭',
		close: '关闭当前',
		refresh: '刷新当前页'
	}
}